import { Account } from "library/accounts/types";

export const getIsEligibleForDebitCard = (account: Account) =>
  account.links.some((link) => link.rel === "debit_card");
